<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    
    <div class="row">
      <div class="col-md-12 mb-3">
        <h3 class="text-transparencia">
          Informes
        </h3>
      </div>
    </div>

    <div v-if="cargando" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
      <p class="mt-3 text-muted">Cargando informes...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      {{ errorMessage }}
    </div>

    <div v-else-if="informes && informes.length > 0" class="row">
      <template v-for="(informe, index) in informes">
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mt-3" :key="index">
          <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
            <a class="fs-13 fw-600 text-center" :href="'/informes/detalle/' + informe.informeId">
              <img 
                v-if="informe.rutaImagenMiniatura" 
                class="img-fluid w-100 rounded cimage-slider" 
                :src="`${filesUrl}${informe.rutaImagenMiniatura}`" 
                :alt="informe.titulo" 
              />
              <div v-else class="img-fluid w-100 rounded cimage-slider d-flex align-items-center justify-content-center bg-light">
                <i class="fa fa-file-alt fa-4x text-muted"></i>
              </div>
            </a>
            <div class="card-body p-2 pt-3" style="height:5.3rem !important;overflow:hidden">
              <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'/informes/detalle/' + informe.informeId">
                <h6 class="card-title fs-15 text-transparencia text-center">{{ informe.titulo }}</h6>
              </a>
            </div>
            <div class="card-footer text-right pt-0">
              <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'/informes/detalle/' + informe.informeId">
                Leer más<i class="fa fa-search-plus ml-1"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-else class="alert alert-info">
      <i class="fa fa-info-circle mr-2"></i>
      No hay informes disponibles en este momento.
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: 'Informes',
  metaInfo: {
    title: "Informes",
  },
  components: {
    layoutBreadcrumb
  },
  data: () => ({
    informes: [],
    cargando: false,
    error: false,
    errorMessage: '',
    breadcrumbs: []
  }),
  methods: {
    async fetchInformes() {
      this.cargando = true;
      this.error = false;

      try {
        const response = await this.$http.get(this.apiRoute('Informe', 'GetInformes'));
        
        if (response.body && response.body.error) {
          this.error = true;
          this.errorMessage = response.body.message || 'Error al cargar los informes';
        } else if (response.body && response.body.data) {
          this.informes = response.body.data;
        } else {
          this.informes = [];
        }
      } catch (error) {
        console.error('Error al cargar informes:', error);
        this.error = true;
        this.errorMessage = 'Error de conexión al servidor';
      } finally {
        this.cargando = false;
      }
    }
  },
  mounted: async function() {
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Informes", url: "/informes", icon: "", active: true },
    ];
    
    await this.fetchInformes();
  }
};
</script>

<style scoped>
.cimage-slider {
  background-color: transparent;
  height: 250px;
  object-fit: contain;
  width: auto !important;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
</style>
